/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { isMobile } from 'react-device-detect';
import Slider from 'react-slick';

import RollingBannerItem from '../../components/banner/RollingBannerItem';

class TopRollingBanner extends Component {
  state = {
    slideIndex: 0,
    slidePlay: true,
    width: 0,
  };
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;
    this._getBanner();

    this.setState({
      width: window.innerWidth,
    });
  };
  resizeListener = () => {
    console.log(window.innerWidth);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getBanner = async () => {
    const result = await this._getBannerApi();
    const intReturn = result.data[0].intReturn;
    const bannerList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          bannerList,
        });
      }

      this._bannerView(
        bannerList[0].idx,
        bannerList[0].adComIdx,
        bannerList[0].pageCode
      );
    }
  };
  _getBannerApi = () => {
    const { apiUrl } = this.props;

    return axios(apiUrl + '/topBannerRolling')
      .then((response) => response)
      .catch((error) => {
        //console.log('error....')
      });
  };
  _renderBanner = () => {
    const { bannerList } = this.state;
    ////console.log(bannerList)
    const list = bannerList.map((item, index) => {
      return (
        /*
                        <div className="div_li" style={{width:760}}>
                            <div className="text_group">
                                <span>정식개봉</span>
                                <h1>뱅드림! 피코 콜라보카페<em>6월18일 오픈!</em></h1>
                            </div>
                            <div className="bg_img"><img src="/img/test_img1.png"/></div>
                        </div>
                   */
        <RollingBannerItem
          key={index}
          bannerFile={item.bannerFile}
          LinkURL={item.LinkURL}
          Linktarget={item.Linktarget}
          LinkURL_M={item.LinkURL_M}
          Linktarget_M={item.Linktarget_M}
          title={item.title}
          idx={item.idx}
          comment={item.comment}
          adComIdx={item.adComIdx}
          pageCode={item.pageCode}
        />
      );
    });

    return list;
  };
  _renderDot = () => {
    const { bannerList } = this.state;

    const list = bannerList.map((item, index) => {
      return (
        <span key={index} className="on"></span>
        /*<a key={index} href="#" className="on"></a>*/
      );
    });

    return list;
  };
  _onNext = () => {
    this.slider.slickNext();
  };
  _onPrev = () => {
    this.slider.slickPrev();
  };
  _onGoto = (i) => {
    ////console.log(i)
    this.slider.slickGoTo(i);
  };
  _onTogglePlay = () => {
    const { slidePlay } = this.state;
    if (slidePlay) {
      this.slider.slickPause();
    } else {
      this.slider.slickPlay();
    }
    this.setState({
      slidePlay: !slidePlay,
    });
  };
  _onPlay = () => {
    this.slider.slickPlay();
  };
  _afterChange = (index, idx) => {
    const { bannerList } = this.state;
    //console.log('aaaa ==> ' + index)
    if (bannerList) {
      if (index >= 0) {
        //console.log(bannerList[index].idx)

        this._bannerView(
          bannerList[index].idx,
          bannerList[index].adComIdx,
          bannerList[index].pageCode
        );
      }
    }
  };
  _beforChange = (current, next) => {
    //const { bannerList } = this.state
    //console.log('aaaa ==> ' + current)
    //if(current > 0) {
    //    console.log(bannerList[current].idx)
    //}
    this.setState({ slideIndex: next });
  };
  _bannerView = async (idx, adComIdx, pageCode) => {
    if (adComIdx === null || adComIdx === undefined || adComIdx === '') {
    } else {
      if (adComIdx !== 1) {
        const result = await this._bannerViewApi(idx, adComIdx, pageCode);
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          //console.log('banner view history...')
        }
      }
    }
  };
  _bannerViewApi = (idx, adComIdx, pageCode) => {
    const { apiUrl, loginId } = this.props;

    return axios.post(apiUrl + '/bannerView', {
      params: {
        userid: loginId,
        idx: idx,
        adComIdx: adComIdx,
        pageCode: pageCode,
      },
    });
  };
  _isTab = () => {
    const { userAgent, maxTouchPoints } = window.navigator;

    const isMac = /Macintosh/i.test(userAgent);

    if (isMac && maxTouchPoints > 0) return true;

    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi|mobi/i.test(
      userAgent
    );
  };
  render() {
    const { bannerList, slideIndex, slidePlay, width } = this.state;
    const { imgUrl } = this.props;
    // const isTab = this._isTab();
    var settings = {
      dots: false,
      //dotsClass: "slick-dots slick-thumb",
      infinite: true,
      //speed: 500,
      slidesToShow: width >= 768 ? 3 : 2,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      //speed: 3000,
      //className: 'slide_baner baner_group baner_div1',
      pauseOnFocus: false,
      //fade: true,
      adaptiveHeight: false,
      centerMode: width >= 1024 ? true : false,

      //variableWidth: true,
      beforeChange: (current, next) => this._beforChange(current, next),
      afterChange: (index) => this._afterChange(index),
    };

    return (
      <Fragment>
        <div className="list_baner">
          <div className="list_banner_title">
            <h2>지금 애니플러스는?</h2>
          </div>
          {width >= 1024 && (
            <>
              <a
                style={{ cursor: 'pointer' }}
                className="left_btn"
                onClick={this._onPrev}
              >
                <span>이전</span>
              </a>
              <a
                style={{ cursor: 'pointer' }}
                className="right_btn"
                onClick={this._onNext}
              >
                <span>다음</span>
              </a>
            </>
          )}

          <div className="div_ul">
            <Slider ref={(ref) => (this.slider = ref)} {...settings}>
              {bannerList ? this._renderBanner() : null}
            </Slider>
          </div>
          {/* <div className="baner_page">
            {bannerList
              ? bannerList.map((i, index) => {
                  //////console.log(index)
                  return (
                    <span
                      key={index}
                      onClick={() => this._onGoto(index)}
                      style={{ cursor: 'pointer' }}
                      className={slideIndex === index ? 'on' : null}
                    ></span>
                  );
                })
              : null}
            <em onClick={this._onTogglePlay} style={{ cursor: 'pointer' }}>
              {slidePlay ? (
                <img src={imgUrl + '/img/stop.png'} />
              ) : (
                <img src={imgUrl + '/img/more2.png'} />
              )}
            </em>
          </div> */}
        </div>

        {/*
                <Slider ref={(ref) => (this.slider = ref)} {...settings} >
                    { bannerList ? this._renderBanner() : null}
                </Slider>
                <div className="location_div">
                    { bannerList ? (
                        bannerList.map((i, index) => {
                            //////console.log(index)
                        return (<a key={index} onClick={()=>this._onGoto(index)} style={{cursor: 'pointer'}} className={slideIndex === index ? "on": null}>{index}</a>)
                        })
                    ) : null}
                    <span onClick={this._onTogglePlay}> {slidePlay ? 'stop' : 'play'}</span>
                </div>
                */}
      </Fragment>
    );
  }
}
export default shopContext(withRouter(TopRollingBanner));

//topBannerRolling
